import EmblaCarousel from "embla-carousel";
import AutoScroll from 'embla-carousel-auto-scroll'

const OPTIONS = { loop: true, containScroll: false };

const emblaNode = document.querySelectorAll(".embla");
if (!emblaNode) return;

emblaNode.forEach((element) => {
  const viewportNode = element?.querySelector(".embla__viewport");

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
    AutoScroll({ playOnInit: true })
  ])
  
  console.log('emblaApi', AutoScroll)

});

